/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ArrowDownIcon = /*#__PURE__*/ createSvgIcon(
  'ArrowDownIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M9.25 13.125V4.75c0-.213.071-.39.214-.535A.72.72 0 019.996 4c.21 0 .39.072.535.215a.72.72 0 01.219.535v8.375l3.67-3.671a.722.722 0 01.528-.225c.201 0 .382.077.541.23a.745.745 0 01-.006 1.058l-4.96 4.954a.721.721 0 01-.526.216.76.76 0 01-.282-.052.69.69 0 01-.236-.156l-4.958-4.958a.693.693 0 01-.219-.531.787.787 0 01.774-.76.71.71 0 01.528.228l3.646 3.667z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ArrowDownIcon;
